import React, { useEffect } from 'react';
import { logCaseVisit } from '../../services/api';

export const IQala = () => {
    useEffect(() => {
        logCaseVisit('IQALA').catch((error) => {
            console.error('Не удалось залогировать посещение кейса IQALA', error);
        });
    }, []);

    return (
        <iframe
            style={{
                width: '100%',
                height: '100%',
                borderRadius: '8px',
                border: '1px solid gray',
            }}
            title="Monitoring state"
            src="https://deeplook.digitalatyrau.kz/public-report/6"
        />
    );
};